import _Promise from 'babel-runtime/core-js/promise';
import Icon from '@xunlei/thunder-ui-vue/lib/icon.js';

var NAMESPACE = 'td';

var Loading = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { directives: [{ name: "show", rawName: "v-show", value: _vm.visible, expression: "visible" }], staticClass: "td-loading-mask" }, [_c('span', { staticClass: "td-loading-mask__icon" }, [_vm._t("default", [_c('td-icon', { attrs: { "type": "loading" } })])], 2), _vm._v(" "), _vm.text ? _c('p', { staticClass: "td-loading-mask__text" }, [_vm._v(_vm._s(_vm.text))]) : _vm._e()]);
  }, staticRenderFns: [],
  name: NAMESPACE + '-loading',

  components: {
    TdIcon: Icon
  },

  props: {
    loading: [Boolean, _Promise],
    text: String
  },

  data: function data() {
    return {
      visible: false
    };
  },


  watch: {
    loading: {
      handler: function handler(val) {
        var _this = this;

        if (typeof val === 'boolean') {
          this.visible = val;
        } else if (val instanceof _Promise) {
          this.visible = true;

          val.finally(function () {
            _this.visible = false;
          });
        }
      },

      immediate: true
    }
  }
};

Loading.install = function (Vue) {
  Vue.component(Loading.name, Loading);
};

export default Loading;
